import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	servicesTitle: {
		id: 'service-management-cmdb-upsell-banner.services-title',
		defaultMessage: 'Map your services with Assets',
		description:
			'Title text for an upsell banner, describing that the user can map out their "services" (from the "Services" ITSM feature) with our product, Assets',
	},
	servicesDescription: {
		id: 'service-management-cmdb-upsell-banner.services-description',
		defaultMessage:
			'Get a deeper understanding of dependencies and other relationships. Upgrade to Premium to connect and consolidate your assets.',
		description:
			'Description text for an upsell banner, encouraging users to upgrade to the Premium version of Jira Service Management',
	},
	featuresTitle: {
		id: 'service-management-cmdb-upsell-banner.features-title',
		defaultMessage: 'Unlock asset and configuration management for your team',
		description:
			'Title text for an upsell banner, directing the user to enable asset and configuration management',
	},
	featuresDescription: {
		id: 'service-management-cmdb-upsell-banner.features-description',
		defaultMessage:
			'Get your team the data they need, when they need it. Connect and consolidate your assets, then surface them inside issues for your team to quickly access.',
		description:
			'Description text for an upsell banner, telling them the functionality they can expect with our Assets product.',
	},
	learnMore: {
		id: 'service-management-cmdb-upsell-banner.learn-more',
		defaultMessage: 'Learn more about Jira Service Management Premium features.',
		description:
			'Text for a link, which will link out to a page describing the functionality available in JSM Premium',
	},
	tryItNow: {
		id: 'service-management-cmdb-upsell-banner.try-it-now',
		defaultMessage: 'Try it now',
		description:
			'Button text on an upsell banner, encouraging users to try out our Premium offering',
	},
	maybeLater: {
		id: 'service-management-cmdb-upsell-banner.maybe-later',
		defaultMessage: 'Maybe later',
		description: 'Button text on an upsell banner, which users can click to dismiss the banner',
	},
});
